// extracted by mini-css-extract-plugin
export default {"installGuide":"InstallGuide_installGuide__Wt8kB","center":"InstallGuide_center__IH6lY"};